import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { ordersService } from '../../services/orders.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-view-bidding',
  templateUrl: './view-bidding.component.html',
  styleUrls: ['./view-bidding.component.css']
})
export class ViewBiddingComponent implements OnInit {

  order: any = null;
  vendorBids: any[] = [];
  isLoading = false;

  // Compare popup
  showCompareDialog = false;
  selectedBid: any = null;
  actionLoading = false;
  counterBidForm!: FormGroup;
  sortColumn: 'status' | 'vendorName' | 'bidAmount' | 'procurementPrice' | 'vehicleProvided' = 'status';
  sortDirection: 'asc' | 'desc' = 'desc';
  role:any;
  // Transaction history popup
  showTransactionDialog = false;
  transactionLoading = false;
  historyTransactions: any[] = [];
  selectedBidForHistory: any = null;

  showWhatsappDialog = false;
  whatsappLoading = false;
  whatsappLogs: any[] = [];
  selectedBidForWhatsapp: any = null;
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private ordersService: ordersService,
    private messageService: MessageService,
    private fb: FormBuilder
  ) {
    const user_details = JSON.parse(localStorage.getItem('UserDetails')!);
    this.role = user_details.roleName;
  }

  ngOnInit(): void {
    this.order = this.config?.data?.order;
    this.buildCounterBidForm();
    if (this.order?.id) {
      this.loadBids(this.order.id);
    }
  }

  loadBids(orderId: any): void {
    this.isLoading = true;
    const filters = [{ key: 'ORDER_ID', value: orderId.toString() }];
    this.ordersService.getVendorOrders(filters, 0, 10000, 'id', 'DESC').subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.vendorBids = res?.responseObject?.content || [];
        this.sortBids('status');
      },
      error: () => {
        this.isLoading = false;
        this.vendorBids = [];
      }
    });
  }

  notPendingOnCustomer(): boolean {
    return this.selectedBid?.status !== 'PendingOnCustomer';
  }
  
  counderNumberValidity(): boolean {
    return (this.selectedBid?.counterNumber ?? 0) > 3;
  }

  isCounterBidEntered(): boolean {
    const val = this.counterBidForm.get('counterBidAmount')?.value;
    return val !== null && val !== undefined && val !== '' && Number(val) > 0;
  }

  getFirstWord(value: string): string {
    return (value || '').trim().split(/\s+/)[0];
  }

  sortBids(column: 'status' | 'vendorName' | 'bidAmount' | 'procurementPrice' | 'vehicleProvided'): void {

    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
  
    this.vendorBids.sort((a: any, b: any) => {
  
      let valueA: any;
      let valueB: any;
  
      switch (column) {
  
        case 'vendorName':
          valueA = (a.vendorName || '').toLowerCase();
          valueB = (b.vendorName || '').toLowerCase();
          break;
  
        case 'bidAmount':
          valueA = +(a.bidAmount || a.procurementPrice || 0);
          valueB = +(b.bidAmount || b.procurementPrice || 0);
          break;
  
        case 'vehicleProvided':
          valueA = +(a.vehicleProvided || a.numberOfVehicle || 0);
          valueB = +(b.vehicleProvided || b.numberOfVehicle || 0);
          break;
  
        case 'status':
        default:
          valueA = this.getStatusOrder(a.status);
          valueB = this.getStatusOrder(b.status);
          break;
      }
  
      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      }
  
      if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      }
  
      return 0;
    });
  }
  
  getStatusOrder(status: string): number {
  
    const order: Record<string, number> = {
      PendingOnCustomer: 1,
      PendingOnVendor: 2,
      AcceptedByCustomer: 3,
      AcceptedByVendor: 4,
      RejectedByCustomer: 5,
      RejectedByVendor: 6
    };
  
    return order[status] ?? 999;
  }

  closeCompare(): void {
    this.showCompareDialog = false;
    this.selectedBid = null;
  }

  buildCounterBidForm(): void {
    this.counterBidForm = this.fb.group({
      counterBidAmount: [null],
      counterVehicles:  [1,   [Validators.required, Validators.min(1)]]
    });
  }
  
  openTranscation(bid: any): void {
    this.selectedBidForHistory = bid;
    this.historyTransactions = [];
    this.transactionLoading = true;
    this.showTransactionDialog = true;
  
    const filterData = [
      { key: 'ORDER_ID_IN', value: bid?.id },
      { key: 'USER_TYPE', value: 'CUSTOMER' }
    ];
  
    this.ordersService.getBiddingTransactions(filterData, 0, 100000, 'id', 'ASC').subscribe({
      next: (res: any) => {
        this.transactionLoading = false;
        this.historyTransactions = res?.responseObject?.content || [];
      },
      error: () => {
        this.transactionLoading = false;
        this.historyTransactions = [];
      }
    });
  }
  
  closeTransactionDialog(): void {
    this.showTransactionDialog = false;
    this.selectedBidForHistory = null;
    this.historyTransactions = [];
  }

  openCompare(bid: any): void {
    this.selectedBid = bid;
    // Pre-fill counter bid with current procurement price
    this.counterBidForm.reset({
      counterBidAmount: null,
      counterVehicles:  this.selectedBid?.numberOfVehicles || this.selectedBid?.numberOfVehicle || 1
    });
    this.showCompareDialog = true;
  }
  
  onCounterBid(): void {
    if (!this.isCounterBidEntered() || this.counterBidForm.get('counterVehicles')?.invalid) {
      this.counterBidForm.markAllAsTouched();
      return;
    }
  
    const formValue = this.counterBidForm.value;
  
    const payload = {
      id:              this.selectedBid.id,
      status:          'PendingOnVendor',       // sends back to vendor
      finalAcceptance: 'CUSTOMER',
      procurementPrice:       formValue.counterBidAmount,
      numberOfVehicle: formValue.counterVehicles
    };
  
    this.actionLoading = true;
  
    this.ordersService.createUpdateOrderBidding(payload).subscribe({
      next: (res: any) => {
        this.actionLoading = false;
        this.showCompareDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res?.responseMessage || 'Counter bid submitted'
        });
        this.loadBids(this.order.id);
      },
      error: (err: any) => {
        this.actionLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.responseMessage || 'Something went wrong'
        });
      }
    });
  }

  onAction(status: 'AcceptedByCustomer' | 'RejectedByCustomer'): void {
    if (!this.selectedBid) return;

    const payload: any = {
      id:              this.selectedBid.id,
      status:          status,
      finalAcceptance: 'VENDOR',
      finalAmount: this.selectedBid.finalAcceptance === 'VENDOR' ? this.selectedBid.bidAmount : this.selectedBid.procurementPrice
    };

    this.actionLoading = true;

    this.ordersService.createUpdateOrderBidding(payload).subscribe({
      next: (res: any) => {
        this.actionLoading = false;
        this.showCompareDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res?.responseMessage || 'Action completed'
        });
        this.loadBids(this.order.id);
      },
      error: (err: any) => {
        this.actionLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.responseMessage || 'Something went wrong'
        });
      }
    });
  }

  statusClass(status: string): string {
    const s = status?.toLowerCase();
    if (s?.includes('accept')) return 'status-accepted';
    if (s?.includes('reject')) return 'status-rejected';
    if (s?.includes('pendingoncustomer')) return 'status-half-accepted';
    if (s?.includes('pending')) return 'status-pending';
    return 'status-default';
  }

  statusLabel(status: string): string {
    if (!status) return '--';
    return status.replace(/([A-Z])/g, ' $1').trim();
  }

  onClose(): void {
    this.ref.close();
  }

  openWhatsappLogs(bid: any): void {

    this.selectedBidForWhatsapp = bid;
    this.showWhatsappDialog = true;
    this.whatsappLoading = true;
    this.whatsappLogs = [];
  
    const filterData = [
      {
        key: 'NOTIFICATION_TYPE',
        value: 'WHATSAPP'
      },
      {
        key: 'REFRENCE_CODE_IN',
        value: bid.orderNumber.toString() + '-' + bid.vendorId.toString()
      }
    ];
  
    this.ordersService
        .getNotificationLogs(filterData)
        .subscribe({
          next: (res: any) => {
            this.whatsappLoading = false;
            this.whatsappLogs = res?.responseObject?.content || [];
            console.log(this.whatsappLogs)
          },
          error: () => {
            this.whatsappLoading = false;
          
            this.whatsappLogs = [];
          }
        });
  }

  closeWhatsappDialog(): void {
    this.showWhatsappDialog = false;
    this.whatsappLogs = [];
    this.selectedBidForWhatsapp = null;
  }
}